import React from "react";
import './About.css';
import Photo from './Shubhra_Srivastava.jpg';
// import Resume from './Shubhra_Srivastava.pdf';
import { NavLink } from "react-router-dom";

const Resume_pdf = 'http://localhost:3000//Shubhra_Srivastava.pdf';
const About=()=>{
   const downloadResume=(url)=>{
     const filename = url.split('/').pop()
     const atag = document.createElement('a')
     atag.href=url;
     atag.setAttribute('download',filename);
     document.body.appendChild(atag)
     atag.click()
     atag.remove();

   };

    return <>
    <div className="responsive-container-block bigContainer" id="about">
  <div className="responsive-container-block Container bottomContainer">
    <div className="ultimateImg">
      <img className="mainImg" src={Photo} alt="alt"/>
      {/* <div className="purpleBox">
        <p className="purpleText">
          Writting Should Always be Logical!
        </p>
        {/* <img className="stars" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/mp5.svg"> */}
      {/* </div> */} 
    </div>
    <div className="allText bottomText">
      
      <p className="text-blk headingText">
        Know Me
      </p>
      
      <p className="text-blk subHeadingText">
      Shubhra Srivastava
      </p>
      <p className="text-blk description">
      Welcome to my extraordinary portfolio! I am a passionate web developer with a keen eye for aesthetics and a dedication to user-centric design.

Get ready to explore a collection of captivating websites that seamlessly blend creativity and functionality. With each project, I strive to create an immersive experience that leaves a lasting impression.

Let's embark on a digital journey together, where innovation meets elegance and technology merges with art. Feel free to reach out and let's make your online presence truly remarkable.
      </p>
      <div className="btn-wrapper">
      <NavLink to="know-me">
      <button className="btn btn-primary explore">
        Know Me More
      </button>
      </NavLink>

     
      <button className="btn btn-primary explore" onClick={()=>{downloadResume(Resume_pdf)}}>
        Downlaod Resume
      </button>
   
      </div>
    </div>
  </div>
</div>
    </>
}

export default About;